<template lang="pug">
  .row
    .col-12
      header.mb-4
        h1#tittle {{$route.name}}
    .col-12
      b-card( border-variant="primary" header-bg-variant="primary" header-text-variant="white")
        template(v-slot:header)
          h5.text-white.m-0 Datos personales
        form(action="/")
          .row.d-flex.flex-wrap
            .form-group.col-md-6
              label Nombres
              input.form-control(type="text" value="Mi nombre" disabled)
            .form-group.col-md-6
              label Apellidos
              input.form-control(type="text" value="Mi apellido" disabled)
            .form-group.col-md-6
              label Rut
              input.form-control(type="text" value="11.111.111-1" disabled)
            .form-group.col-md-6
              label E-mail
              input.form-control(type="email" value="micorreo@miemepresa.cl" disabled)
      b-card.my-5( border-variant="primary" header-bg-variant="primary" header-text-variant="white")
        template(v-slot:header)
          h5.text-white.m-0 Permisos de aplicaciones
        .card-body
          form(action="/")
            .row.d-flex.flex-wrap
              .form-group.form-check.col-6.col-md-3(v-for="app in apps")
                input.form-check-input(type="checkbox" :id="app.id" :value="app.id" disabled)
                label.form-check-label(:for="app.id") {{app.name}}
    .col-12.d-flex.justify-content-between.mb-5
      button.btn.btn-light.px-5 Volver
</template>

<script>
// @ is an alias to /src
import DefaultLayout from '@/layouts/DefaultLayout'

export default {
  name: 'userAcount',
  data () {
    return {
      apps: [
        { id: 'app-1', name: 'App 1' },
        { id: 'app-2', name: 'App 2' },
        { id: 'app-3', name: 'App 3' },
        { id: 'app-4', name: 'App 4' },
        { id: 'app-5', name: 'App 5' }
      ]
    }
  },
  methods: { },
  created () {
    this.$emit('update:layout', DefaultLayout)
  }
}
</script>

<style lang="stylus" scoped>
  #tittle
    color: #43ADE1
</style>
